import { PROJECTS, PRODUCTS } from '../../../utils/constants'

const getProjectCategoriesData = (activeCategories, comingCategory, filters) => {
  let currentCategory = ''
  const { categories } = filters
  categories.some(category => {
    currentCategory = category
    if (currentCategory.slug !== comingCategory) return false
    return true
  })
  return currentCategory
}

const getProductCategoriesData = (parentCategories, currentCategory, filters) => {
  let currentFilterData = ''

  Object.keys(parentCategories).some(category => {
    const currentPath = filters[category][0].path === currentCategory
    if (!currentPath) return false;
    [currentFilterData] = filters[category]
    return true
  })
  return currentFilterData
}
export const filteredCategoriesPerType = {
  [PROJECTS]: getProjectCategoriesData,
  [PRODUCTS]: getProductCategoriesData
}

export const dataTypeFollowButton = type => {
  switch (type) {
    case PROJECTS:
      return 'category'

    case PRODUCTS:
      return 'product_category'
  }
}